var Promise = require('promise');
import HelpService from './help.service';

export default (function() {
    function E3TranslateService() {
        const instance = this.constructor.instance;
        if (instance) {
            return instance;
        }

        this.constructor.instance = this;

        this._helpService = new HelpService();
        this._language = 'en';
        this._languages = [];
//      v_1 - this._translateURL = 'https://spreadsheets.google.com/feeds/list/1RKcibJiB6XSeF3l3HDuaFxvBGyIiYKgM-jx9LSC0Rvg/od6/public/basic?alt=json';
//      v_1 - this._translateURL = `https://www.eyespy360.com/strings/e3-viewer.json?timestamp=${new Date().getTime()}`;

//      v_2 - https://docs.google.com/spreadsheets/d/1RKcibJiB6XSeF3l3HDuaFxvBGyIiYKgM-jx9LSC0Rvg/gviz/tq?tqx=out:json
        const _cid = typeof window !== 'undefined' && window._e3cid;
        this._translateURL = `https://www.eyespy360.com/strings/e3-viewer_v2.txt?timestamp=${new Date().getTime()}${_cid ? '&companyID=' + _cid : ''}`;
        this._vocabulary = {};
        this._getTranslationPromise = null;
    }

    E3TranslateService.prototype.getTranslation = getTranslation;
    E3TranslateService.prototype._getTranslation = _getTranslation;
    E3TranslateService.prototype.translate = translate;

    function _getTranslation(lang) {
        this._getTranslationPromise = new Promise((resolve, reject) => {
            this._language = lang;
            this._helpService.ajaxCall(this._translateURL)
                .then((data) => {
                    const r = data.match(/google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/);
                    if (r && r.length == 2) {
                        const obj = JSON.parse(r[1]);
                        const table = obj.table;
                        const rows = table.rows.map(({c}) => c.map(e => e ? (e.v || "") : "")); // Modified from const rows = table.rows.map(({c}) => c.map(({v}) => v));

                        this._languages.push(...rows.shift());

                        const updateRow = rows.map((row) => {
                            return row.map((word, ind) => {
                                return { [this._languages[ind]]: word};
                            })
                        })

                        let countRows = updateRow.length;
                        const vocabularyObj = {};

                        while (countRows--) {
                            let obj = {}
                            updateRow[countRows].slice(1, updateRow[countRows].length).forEach((rowObj) => {
                                obj = {...obj, ...rowObj}
                            })

                            vocabularyObj[updateRow[countRows][0]['string_id']] = obj;
                        }
                        this._languages.shift();
                        this._vocabulary = vocabularyObj;

                        if (this._languages.indexOf(this._language) === -1) this._language = 'en';
                        resolve(vocabularyObj);
                    }
                })
                .catch((err) => reject(err))
        });

        return this._getTranslationPromise
    }

    function getTranslation(lang) {
        const language = lang ? lang.slice(0, 2) : lang;
        return this._getTranslationPromise || this._getTranslation(language);
    }

    function translate(text) {
        if(this._vocabulary[text]){
            return this._vocabulary[text][this._language];
        }else{
            return text;
        }
    }

    return E3TranslateService;
})();

